<template>
  <div class="horizon-toolbar d-flex align-center justify-space-between flex-wrap gap-3" data-testid="horizon-toolbar">
    <div class="d-flex align-center flex-wrap gap-3" data-testid="horizon-toolbar__left">
      <RoleSwitcher
        :value="userType"
        :show-manager="showManagerRole"
        :show-preparer="false"
        @change="$emit('role-change', $event)"
      />
      <v-divider vertical></v-divider>
      <HorizonFilter
        :horizon-filters="horizonFilters"
        :active-filters="activeFilters"
        @filter-change="$emit('filter-change', $event)"
      />
    </div>
    <div class="d-flex align-center gap-2" data-testid="horizon-toolbar__right">
      <v-divider vertical class=""></v-divider>
      <lb-date-picker
        :value="dateRange"
        :max-days="maxDays"
        :min-days="minDays"
        :cycle-start="cycleStart"
        :cycle-end="cycleEnd"
        @input="onDateRangeInput"
        data-testid="date-range-selector"
      />
    </div>
  </div>
</template>

<script>
import './HorizonToolbar.scss';
import RoleSwitcher from '../../../components/RoleSwitcher/RoleSwitcher.vue';
import HorizonFilter from './HorizonFilter.vue';
import { HORIZON_DATE_WINDOW } from '../../../utils/horizonConstants';

/** Top toolbar: role switcher, filter chips, and horizon date-range picker. */
export default {
  name: 'HorizonToolbar',
  components: {
    RoleSwitcher,
    HorizonFilter,
  },
  props: {
    userType: {
      type: String,
      default: 'manager',
    },
    showManagerRole: {
      type: Boolean,
      default: true,
    },
    horizonFilters: {
      type: Object,
      default: () => ({}),
    },
    activeFilters: {
      type: Object,
      default: () => ({}),
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    cycleStart: {
      type: String,
      default: '',
    },
    cycleEnd: {
      type: String,
      default: '',
    },
  },
  computed: {
    /** Two-element array for lb-date-picker [start, end]. */
    dateRange() {
      if (this.startDate && this.endDate) {
        return [this.startDate, this.endDate];
      }
      return [];
    },
    /** Minimum allowed horizon window length (from horizonConstants). */
    minDays() {
      return HORIZON_DATE_WINDOW.MIN_DAYS;
    },
    /** Maximum allowed horizon window length (from horizonConstants). */
    maxDays() {
      return HORIZON_DATE_WINDOW.MAX_DAYS;
    },
  },
  methods: {
    /** Forwards validated date range from picker to HorizonLanding. */
    onDateRangeInput(range) {
      if (!Array.isArray(range) || range.length < 2) return;
      const [start, end] = range;
      this.$emit('date-range-change', { start, end });
    },
  },
};
</script>
